import en from './en-US'
import fr from './fr-FR'

export default {
    ...en,
    ...fr,
}
